import type { RumEvent } from '@datadog/browser-rum';

export const stripUrlQuery = (value: string) => {
  try {
    const { origin, pathname } = new URL(value);
    return `${origin}${pathname}`;
  } catch {
    return value.replace(/[?#].*$/, '');
  }
};

// beforeSend hands over a live event and keys off the boolean return, so the URLs are mutated in place.
export const scrubRumEventUrls = (event: RumEvent) => {
  event.view.url = stripUrlQuery(event.view.url);

  if (typeof event.view.referrer === 'string') {
    event.view.referrer = stripUrlQuery(event.view.referrer);
  }

  if (event.type === 'resource') {
    event.resource.url = stripUrlQuery(event.resource.url);
  }

  return true;
};
